import { useState } from "react";
import { MonitorCog, ShieldCheck, SlidersHorizontal, Users } from "lucide-react";
import type { SimulatorAppSurfaceProps } from "../AppSurface.js";

const remoteTabs = ["General", "Display", "Local Resources", "Experience", "Advanced"];

export function RemoteAccessApp({ activeMachine, app, onRunCommand }: SimulatorAppSurfaceProps) {
  const [selectedTab, setSelectedTab] = useState("General");
  const [computerName, setComputerName] = useState(
    activeMachine.toUpperCase().startsWith("SRV") ? "SRV01.advanced-ti.local" : `${activeMachine}.lab.local`
  );
  const [username, setUsername] = useState("LAB\\Student");
  const [groupName, setGroupName] = useState("Remote Access Users");

  async function setRemoteAccess(enabled: boolean) {
    await onRunCommand({
      appId: app.id,
      commandType: "RDP_ENABLE",
      capability: "remoteDesktop.write",
      label: `${enabled ? "Enable" : "Disable"} remote access`,
      payload: {
        allowedGroups: [groupName],
        computerName,
        enabled,
        firewallRuleName: "Remote Access TCP-In",
        machineId: activeMachine,
        username
      }
    });
  }

  async function allowGroup() {
    await onRunCommand({
      appId: app.id,
      commandType: "RDP_SET_ALLOWED_GROUP",
      capability: "remoteDesktop.write",
      label: "Allow remote access group",
      payload: {
        groupName,
        machineId: activeMachine
      }
    });
  }

  return (
    <div className="fd-sim-app fd-sim-remote-access">
      <section className="fd-remote-card">
        <header className="fd-remote-header">
          <span className="fd-remote-icon"><MonitorCog size={34} /></span>
          <div>
            <p>{activeMachine}</p>
            <h2>Remote Access Connection</h2>
          </div>
        </header>
        <div className="fd-remote-tabs" role="tablist" aria-label="Remote access settings">
          {remoteTabs.map((tab) => (
            <button
              aria-selected={selectedTab === tab}
              className={selectedTab === tab ? "is-active" : ""}
              key={tab}
              role="tab"
              type="button"
              onClick={() => setSelectedTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
        <div className="fd-remote-content">
          <div className="fd-network-form-grid">
            <label>
              Computer
              <input value={computerName} onChange={(event) => setComputerName(event.target.value)} />
            </label>
            <label>
              User name
              <input value={username} onChange={(event) => setUsername(event.target.value)} />
            </label>
            <label>
              Allowed group
              <input value={groupName} onChange={(event) => setGroupName(event.target.value)} />
            </label>
          </div>
          <div className="fd-remote-summary">
            <div>
              <ShieldCheck size={18} />
              <span>Secure remote sign-in</span>
              <strong>Service and firewall state are updated together</strong>
            </div>
            <div>
              <Users size={18} />
              <span>Allowed group</span>
              <strong>{groupName}</strong>
            </div>
            <div>
              <SlidersHorizontal size={18} />
              <span>Selected tab</span>
              <strong>{selectedTab}</strong>
            </div>
          </div>
          <div className="fd-network-actions">
            <button type="button" onClick={() => void setRemoteAccess(true)}>
              <ShieldCheck size={16} />
              Enable access
            </button>
            <button type="button" onClick={() => void setRemoteAccess(false)}>
              Disable access
            </button>
            <button type="button" onClick={() => void allowGroup()}>
              <Users size={16} />
              Allow group
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
